import { Controller } from "@hotwired/stimulus"

const KEY = "appearance"
const MODES = ["light", "dark", "system"]

// Connects to data-controller="ui--appearance"
//
// Hotwire port of the React `use-appearance` hook: persists the theme in
// localStorage["appearance"] (removed when "system"), toggles `.dark` on <html>
// + sets `color-scheme`, and live-updates on OS preference change while in
// system mode.
//
// Uses DOCUMENT-level listeners (not data-action) because the theme items live
// inside the dropdown menu content, which is portaled to <body> on open — that
// moves them out of Stimulus scope, so element-scoped actions would not fire.
export default class extends Controller {
  connect() {
    this.onClick = this.handleClick.bind(this)
    this.onSystemChange = this.applyStored.bind(this)
    this.media = window.matchMedia("(prefers-color-scheme: dark)")

    document.addEventListener("click", this.onClick)
    this.media.addEventListener("change", this.onSystemChange)

    this.applyStored()
    this.markActive(this.current)
  }

  disconnect() {
    document.removeEventListener("click", this.onClick)
    this.media?.removeEventListener("change", this.onSystemChange)
  }

  handleClick(event) {
    const el = event.target.closest("[data-appearance]")
    if (!el) return
    const mode = el.dataset.appearance
    if (MODES.includes(mode)) this.set(mode)
  }

  set(mode) {
    if (mode === "system") {
      localStorage.removeItem(KEY)
    } else {
      localStorage.setItem(KEY, mode)
    }
    this.apply(mode)
    this.markActive(mode)
  }

  get current() {
    return localStorage.getItem(KEY) || "system"
  }

  applyStored() {
    this.apply(this.current)
  }

  apply(mode) {
    const isDark = mode === "dark" || (mode === "system" && this.media.matches)
    document.documentElement.classList.toggle("dark", isDark)
    document.documentElement.style.colorScheme = isDark ? "dark" : "light"
  }

  // Reflect the active theme onto the menu items (visual, matches React `active`).
  markActive(mode) {
    document.querySelectorAll("[data-appearance]").forEach((el) => {
      const active = el.dataset.appearance === mode
      el.classList.toggle("bg-primary/10", active)
      el.classList.toggle("text-primary", active)
    })
  }
}
